import {
  AuthService,
  AuthProviders,
} from './auth.service';
import {
  Observable,
  throwError,
  of
} from 'rxjs';
import { Injectable } from '@angular/core';
import { DxUser } from '@digitaix/types';

@Injectable()
export class AuthServiceMock<User = DxUser, Provider = AuthProviders> extends AuthService<User, Provider> {

  public signInWithEmailAndPassword(
    email: string,
    password: string,
  ): Observable<any> {
    return of(true);
  }

  public signOut(): Observable<any> {
    this.reset();
    return of(true);
  }

  public createUserWithEmailAndPassword(
    email: string,
    password: string,
  ): Observable<any> {
    return of(true);
  }

  public sendPasswordResetEmail(email: string): Observable<any> {
    return of(true);
  }

  public sendEmailVerification(): Observable<any> {
    return of(true);
  }

  public signInWithProvider(provider: Provider): Observable<any> {
    return of(true);
  }

  public applyActionCode(oobCode: string): Observable<any> {
    return of(true);
  }

  public createUser(email: string, password: string): Observable<any> {
    return of(true);
  }

  public reset(): void {
    this.user.next(null);
  }

}
